
import { environment } from '../../environments/environment';
import { APPLICATION_ID } from './constants';

export class LoginModel
{
    public email: string;
    public password: string;
    public client_id: string = environment.client_id;
    public impersonation_id: string;
    public device_token: string;
    public application_id: string =APPLICATION_ID;
}

export class VerifyOTPModel
{
    public otp_id: string;
    public otp_code: string;
    public client_id: string = environment.client_id;
    public application_id: string =APPLICATION_ID;

}

export class UserMFASettingModel
{
    public email: string;
    public user_id: string;
    public mfa_enabled: boolean;
    public application_id: string =APPLICATION_ID;
    public mfa_method: string;

}
